export const LOADING = Symbol('LOADING');
export type Loader<Content, Err extends Error> = typeof LOADING | Content | Err;
